import { css } from '@emotion/react';

import COLORS from 'shared/styles/colors';
import { mediaquery } from 'shared/styles/styleFunctions';
import theme from 'shared/styles/themes';

export const verticalStepHeaderStyles = css({
  '&.step-nav': {
    alignItems: 'center',
    justifyContent: 'start',
  },
  '.step-nav': {
    '&__icon': {
      alignItems: 'center',
      justifyContent: 'center',
      width: '24px',
      height: '24px',
      backgroundColor: COLORS.NEUTRAL200,
      color: 'white',
      borderRadius: '50%',
    },
    '&__icon--active': {
      backgroundColor: COLORS.PRIMARY500,
    },
    '&__icon--completed': {
      backgroundColor: COLORS.PRIMARY500,
    },
    '&__title': {
      marginLeft: '5px',
    },
    '&__title--clickable, &__icon--clickable': {
      cursor: 'pointer',
    },
  },
});

export default css({
  '&.vertical-step': {
    '&:last-of-type .vertical-step__content-wrapper, &:last-of-type .vertical-step__subtitle': {
      borderLeft: 'none',
    },
    '& .multi-step-form__btn-wrapper': {
      display: 'flex',
      alignContent: 'center',
    },
    '& .multi-step-form__continue-btn': {
      marginTop: theme.space[4],
      marginRight: theme.space[4],
    },
    '& .multi-step-form__optional-btn': {
      marginTop: theme.space[4],
    },
  },
  '.vertical-step': {
    '&__content-wrapper': {
      flexDirection: 'column',
      width: '90%',
      borderLeft: `solid 1px ${COLORS.NEUTRAL100}`,
      minHeight: '20px',
      marginLeft: '10px',
      paddingLeft: '10px',
      paddingTop: theme.space[2],
      [mediaquery.md]: {
        width: '100%',
      },
    },
    '&__subtitle': {
      marginLeft: '10px',
      marginBottom: '0',
      paddingLeft: '25px',
      borderLeft: `solid 1px ${COLORS.NEUTRAL100}`,
    },
    '&__body': {
      flexDirection: 'column',
      height: 'min-content',
      flexWrap: 'nowrap',
      width: '100%',
      marginBottom: theme.space[6],
      [mediaquery.md]: {
        maxWidth: '800px',
      },
    },
    '&__body--confirmation': {
      [mediaquery.md]: {
        maxWidth: 'unset',
      },
    },
    '&__prompt-btn': {
      padding: 0,
      textAlign: 'left',
    },
    '&__prompt-btn:disabled': {
      opacity: 1,
    },
    '&__prompt-btn:hover .vertical-step__edit-icon': {
      color: COLORS.WHITE,
    },
    '&__prompt-btn:hover': {
      color: COLORS.BLACK,
    },
  },
});
